// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2gjkk","containerItemsCenter":"Skeleton_containerItemsCenter__1huFz"};